import React, { useState } from 'react';
import loadable from '@loadable/component';
import { returnResizedImageURL } from '@accrosoft-ltd/accropress-websites-components/dist/esm/imgUtils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var WeducNotices = loadable(function () {
  return import('@accrosoft-ltd/accropress-websites-components/dist/esm/weducNotices');
});
var WigLoader = loadable(function () {
  return import('@accrosoft-ltd/accropress-websites-components/dist/esm/wigLoader');
});

var HeroInnerContent = function HeroInnerContent(props) {
  var _useState = useState(null),
      sidebarLinksActive = _useState[0],
      setSidebarLinksActive = _useState[1];

  var pluginOptions = props.pluginOptions;
  return /*#__PURE__*/_jsxs("div", {
    className: "HeroInnerContent",
    children: [pluginOptions.quickLinksType === 'normal' && props.contentDataData[0] && props.contentDataData[0].children[4] && props.contentDataData[0].children[4].children && /*#__PURE__*/_jsx("div", {
      className: "bannerSidebar",
      children: props.contentDataData[0].children[4].children.map(function (col, index) {
        return /*#__PURE__*/_jsxs("div", {
          className: "bannerSidebar_Item",
          children: [/*#__PURE__*/_jsx("div", {
            className: "bannerSidebar_Item_Opener bounce",
            onClick: function onClick() {
              return setSidebarLinksActive(sidebarLinksActive !== index ? index : null);
            },
            children: /*#__PURE__*/_jsxs("div", {
              className: "bannerSidebar_Item_Opener_Content",
              children: [/*#__PURE__*/_jsx("div", {
                className: "bannerSidebar_Item_Opener_Icon",
                children: /*#__PURE__*/_jsx("span", {
                  className: col[0].value
                })
              }), /*#__PURE__*/_jsx("div", {
                children: col[1].value
              })]
            })
          }), sidebarLinksActive === index && /*#__PURE__*/_jsxs("div", {
            className: "bannerSidebar_Item_Content",
            children: [/*#__PURE__*/_jsx("button", {
              className: "close",
              onClick: function onClick() {
                return setSidebarLinksActive(sidebarLinksActive !== index ? index : null);
              },
              children: /*#__PURE__*/_jsx("span", {
                className: "fal fa-times"
              })
            }), /*#__PURE__*/_jsx(WigLoader, {
              weducWebsitesID: props.config.weducWebsitesID,
              weducContainer: props.config.weducContainerID,
              weducEntity: props.config.weducEntityID,
              contentDataData: props.contentDataData,
              contentMetaData: props.contentMetaData,
              contentDataArray: "0",
              contentDataChild: "4",
              customDataArray: col[2].value,
              AccroPressProdEndpoint: props.config.apiEndpoint,
              AccroPressLocalEndpoint: props.config.apiEndpoint,
              integratorID: props.config.integratorID,
              integratorAccessToken: props.config.integratorAccessToken,
              imageFormatting: process.env.IMAGE_FORMATTING_SECRET || process.env.GATSBY_IMAGE_FORMATTING_SECRET
            })]
          })]
        });
      })
    }), props && props.contentDataData && props.setNoticesMainLoaded && props.NoticeTemplate && props.toggleNoticesBanner && props.config && props.pluginOptions && /*#__PURE__*/_jsxs(_Fragment, {
      children: [!props.pluginOptions.useHeroSlider && /*#__PURE__*/_jsxs("div", {
        className: "banner home-banner",
        children: [!props.pluginOptions.hideScroller && /*#__PURE__*/_jsx("div", {
          className: "arrow-container",
          children: /*#__PURE__*/_jsx("div", {
            className: "arrow-down",
            children: /*#__PURE__*/_jsx("div", {
              children: /*#__PURE__*/_jsxs("button", {
                activeclass: "active",
                className: "btn scroll",
                type: "submit",
                value: "Scroll Here",
                onClick: function onClick() {
                  return props.scrollToContent('scrollHere', -140);
                },
                children: [/*#__PURE__*/_jsx("div", {
                  children: "Scroll"
                }), /*#__PURE__*/_jsx("span", {
                  className: "fal fa-angle-down"
                })]
              })
            })
          })
        }), /*#__PURE__*/_jsx("div", {
          className: "hero",
          style: {
            backgroundImage: "\n                url(\"" + (props.contentDataData[0].children[0] && props.contentDataData[0].children[0].children && props.contentDataData[0].children[0].children[0] && props.contentDataData[0].children[0].children[0][0] && props.contentDataData[0].children[0].children[0][0].value ? returnResizedImageURL({
              w: 1900
            }, props.contentDataData[0].children[0].children[0][0].value) : '/banner.jpg') + "\")"
          },
          children: props.pluginOptions.heroVideoURL && /*#__PURE__*/_jsxs("video", {
            id: "hero_video_player",
            className: "hero__video",
            loop: true,
            muted: true,
            preload: "metadata",
            autoPlay: true,
            playsInline: true,
            children: [/*#__PURE__*/_jsx("source", {
              className: "video__source",
              type: "video/mp4",
              "data-src": props.pluginOptions.heroVideoURL
            }), props.pluginOptions.heroVideoURL_OGG && /*#__PURE__*/_jsx("source", {
              className: "video__source",
              "data-src": props.pluginOptions.heroVideoURL_OGG,
              type: "application/ogg"
            }), props.pluginOptions.heroVideoURL_WEBM && /*#__PURE__*/_jsx("source", {
              className: "video__source",
              "data-src": props.pluginOptions.heroVideoURL_WEBM,
              type: "video/webm"
            })]
          })
        })]
      }), /*#__PURE__*/_jsx("div", {
        className: "bannerWrapper",
        children: /*#__PURE__*/_jsx("div", {
          className: "container",
          children: /*#__PURE__*/_jsx("div", {
            className: "row",
            children: /*#__PURE__*/_jsxs("div", {
              className: "bannerContainer",
              children: [/*#__PURE__*/_jsxs("div", {
                className: "bannerText hero_bannerText",
                children: [props.contentDataData[0] && props.contentDataData[0].children[1] && props.contentDataData[0].children[1].value && /*#__PURE__*/_jsx("h1", {
                  children: props.contentDataData[0].children[1].value
                }), props.contentDataData[0] && props.contentDataData[0].children[2] && props.contentDataData[0].children[2].value && /*#__PURE__*/_jsx("h2", {
                  children: props.contentDataData[0].children[2].value
                }), props.contentDataData[0] && props.contentDataData[0].children[3] && props.contentDataData[0].children[3].value && /*#__PURE__*/_jsx(WigLoader, {
                  weducWebsitesID: props.config.weducWebsitesID,
                  weducContainer: props.config.weducContainerID,
                  weducEntity: props.config.weducEntityID,
                  contentDataData: props.contentDataData,
                  contentMetaData: props.contentMetaData,
                  contentDataArray: "0",
                  contentDataChild: "3",
                  AccroPressProdEndpoint: props.config.apiEndpoint,
                  AccroPressLocalEndpoint: props.config.apiEndpoint,
                  integratorID: props.config.integratorID,
                  integratorAccessToken: props.config.integratorAccessToken,
                  imageFormatting: process.env.IMAGE_FORMATTING_SECRET || process.env.GATSBY_IMAGE_FORMATTING_SECRET
                })]
              }), !props.pluginOptions.hideNotices && /*#__PURE__*/_jsx("div", {
                className: "banner-inner weducWidgetDisplay_" + props.noticesMainLoaded,
                children: /*#__PURE__*/_jsxs("div", {
                  className: props.noticesBannerExpanded ? 'close-alert' : 'open',
                  children: [/*#__PURE__*/_jsx("div", {
                    className: "bannerTextClose",
                    children: /*#__PURE__*/_jsx("button", {
                      onClick: function onClick() {
                        return props.toggleNoticesBanner();
                      },
                      children: /*#__PURE__*/_jsx("span", {
                        children: props.noticesBannerExpanded ? '' : ''
                      })
                    })
                  }), /*#__PURE__*/_jsx("div", {
                    className: "bannerText",
                    children: /*#__PURE__*/_jsx(WeducNotices, {
                      delay: 5,
                      limit: 1,
                      name: props.config.weducWebsitesID,
                      container: props.config.weducEntityID,
                      html: props.NoticeTemplate,
                      loadedEvent: props.setNoticesMainLoaded
                    })
                  })]
                })
              })]
            })
          })
        })
      })]
    })]
  });
};

export default HeroInnerContent;